import produce from 'immer';
export var getInitialState = function () { return ({
    loading: false,
    updating: false,
    error: false,
    environments: [],
    files: [],
    filesMeta: {},
}); };
function environmentsReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'LOAD_ENVIRONMENT_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'LOAD_ENVIRONMENT_SUCCESS':
                state.loading = false;
                state.error = false;
                state.environments = action.environments || [];
                break;
            case 'LOAD_ENVIRONMENT_FAILURE':
                state.loading = false;
                state.error = true;
                state.environments = [];
                break;
            case 'CREATE_ENVIRONMENT_REQUEST':
            case 'UPDATE_ENVIRONMENT_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'CREATE_ENVIRONMENT_SUCCESS':
            case 'UPDATE_ENVIRONMENT_SUCCESS':
                state.loading = false;
                state.error = false;
                state.environments = action.environments || [];
                break;
            case 'CREATE_ENVIRONMENT_FAILURE':
            case 'UPDATE_ENVIRONMENT_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'DELETE_ENVIRONMENT_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'DELETE_ENVIRONMENT_SUCCESS':
                state.loading = false;
                state.error = false;
                state.environments = state.environments.filter(function (l) { return l.id !== action.stateId; });
                break;
            case 'DELETE_ENVIRONMENT_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'ENVIRONMENT_LOAD_FILES_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'ENVIRONMENT_LOAD_FILES_SUCCESS':
                state.files = action.files || [];
                state.filesMeta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case 'ENVIRONMENT_LOAD_FILES_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            default:
                break;
        }
    });
}
export default environmentsReducer;
